// extracted by mini-css-extract-plugin
export default {"faq":"styles_faq__hWYcg"};